/**
 * 1.3.0 Intake (/intake/*, permission portal.review): every media portal upload waits here for review. Stream P4's
 * page: the list (/intake) and one submission's page (/intake/:id). Files under pages/intake/ are P4's.
 */
import { Inbox } from 'lucide-react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { useMe } from '../../api/hooks';
import { IntakeList } from './IntakeList';
import { IntakeSubmissionPage } from './IntakeSubmission';

export function Intake() {
  const me = useMe().data;
  if (!me?.permissions.includes('portal.review')) return <Navigate to="/library" replace />;
  return (
    <Routes>
      <Route index element={<IntakeList />} />
      <Route path=":id" element={<IntakeSubmissionPage />} />
      <Route path="*" element={<Navigate to="/intake" replace />} />
    </Routes>
  );
}

export const IntakeIcon = () => <Inbox size={16} color="var(--accent-strong)" />;
